import { IconInfinity, IconBolt, IconAdjustments, IconWifi, IconHash, IconDeviceGamepad, IconAdjustmentsHorizontal, IconActivity, IconTrophy, IconBrandDiscord, IconBrandTwitter, IconShieldCheck, IconCloudDownload, IconClock, IconPlayerStop } from '@tabler/icons-react';

export const HOME_CONTENT = {
    hero: {
        title: "#1 FREE Kahoot Bot",
        subtitle: "Smash any Kahoot Game in seconds. Unlock unlimited bots, real-time control, and more.",
        cta: "Launch Bots",
        features: [
            { icon: IconInfinity, title: "Unlimited Bots", desc: "Flood games instantly" },
            { icon: IconBolt, title: "Blazing Fast", desc: "Instant join speeds" },
            { icon: IconAdjustments, title: "Customizable", desc: "Control names & answers" },
            { icon: IconWifi, title: "Always Online", desc: "99.9% Uptime Guarantee" }
        ]
    },
    features: {
        badge: "NEW FEATURES",
        title: "Dominate Games",
        titleHighlight: "with our Dashboard",
        description: "Most Kahoot Bots give users zero control. Our Dashboard updates every second giving users maximum control.",
        items: [
            {
                icon: IconAdjustmentsHorizontal,
                color: 'cyan',
                title: 'Dynamic Control Modes',
                desc: "Switch between 'Random' mode for chaos, or 'Manual' mode to answer via our virtual joystick, controlling your bot's answers."
            },
            {
                icon: IconActivity,
                color: 'orange',
                title: 'Live Event Feed',
                desc: "Stay updated with a real-time timeline of game events, from bot connections to time left to answer."
            },
            {
                icon: IconTrophy,
                color: 'yellow',
                title: 'Game Analytics',
                desc: "Our technology automatically detects and captures the podium, proving your dominance."
            }
        ]
    },
    howItWorks: {
        title: "Start Smashing in",
        titleHighlight: "Seconds",
        subtitle: "Three simple steps to take total control of the lobby.",
        steps: [
            {
                step: '01',
                title: 'Enter Game PIN',
                description: 'Enter the game PIN into the dashboard to connect to your lobby.',
                icon: IconHash,
                color: 'blue'
            },
            {
                step: '02',
                title: 'Configure Bots',
                description: 'Choose your bot name, or randomly generate one, and decide how many bots you would like.',
                icon: IconAdjustments,
                color: 'cyan'
            },
            {
                step: '03',
                title: 'Control Dashboard',
                description: 'Choose to answer questions yourself, or let us randomly pick answers and stay up-to-date with the game.',
                icon: IconDeviceGamepad,
                color: 'grape'
            },
        ]
    },
    comparison: {
        badge: "UNMATCHED POWER",
        title: "Why we are the",
        titleHighlight: "#1 Choice",
        description: "Don't settle for basic Kahoot Bots that barely work. We provide a safe and custom designed platform designed for you.",
        ourName: "Kahoot Bot",
        rows: [
            { feature: 'Join Speed', us: 'Instant (WebSockets)', them: 'Slow (HTTP Polling)' },
            { feature: 'Live Dashboard', us: 'Real-time Controls', them: 'Static / None' },
            { feature: 'Podium Tracking', us: 'Automatic Capture', them: 'None' },
            { feature: 'VPN/Proxy', us: 'Integrated (Free)', them: 'Paid / Manual' },
            { feature: 'Anti-Ban', us: 'Stealth Mode', them: 'Instant IP Ban' },
        ],
        testimonials: {
            title: "Reviews",
            items: [
                { name: "Alex_Slayer", platform: "discord", msg: "Just spammed the lobby in 2 seconds. The teacher was so confused!", time: "1y ago", color: "indigo", icon: IconBrandDiscord },
                { name: "KahootKing99", platform: "discord", msg: "Manual mode actually works. It showed me the podium before the screen even showed it!", time: "4m ago", color: "red", icon: IconBrandDiscord },
                { name: "SarahJ", platform: "twitter", msg: "Used the manual joystick to answer for my whole team. We got 1st place easily.", time: "3m ago", color: "blue", icon: IconBrandTwitter },
                { name: "GlitchMaster", platform: "discord", msg: "The question timer is insane. I can control an entire team just from my dashboard.", time: "3m ago", color: "green", icon: IconBrandDiscord },
            ]
        }
    },
    faq: {
        title: "Frequently Asked",
        titleHighlight: "Questions",
        subtitle: "Common questions about this specific tool. Can't find the answer you're looking for?",
        items: [
            {
                id: 'software',
                question: 'Do I need to install any software?',
                answer: 'No! Our platform runs entirely in the cloud. You can flood games from your iPhone, Android, Chromebook, or any device with a browser.',
                icon: IconCloudDownload,
                color: 'blue'
            },
            {
                id: 'safe',
                question: 'Is this safe and secure to use?',
                answer: 'Absolutely. We use enterprise-grade encryption and proxies. Your IP address is never exposed.',
                icon: IconShieldCheck,
                color: 'teal'
            },
            {
                id: 'limit',
                question: 'Is there a limit to how many bots I can send?',
                answer: 'Free users can send up to 50 bots per game. In the future, premium members may send more.',
                icon: IconClock,
                color: 'orange'
            },
            {
                id: 'stop',
                question: 'Can I stop the bots mid-game?',
                answer: 'Yes. The "Terminate Session" button in your dashboard instantly disconnects them.',
                icon: IconPlayerStop,
                color: 'red'
            }
        ]
    },
    preFooter: {
        title: "Ready to",
        titleHighlight: "bot",
        titleSuffix: "the game?",
        subtitle: "Join thousands of students having fun right now.",
        cta: "Launch Bots",
        footerText: "Free to use • Instant access"
    },
    modal: {
        botDashboard: "Bot Dashboard"
    },
    footer: {
        description: "The world's most advanced educational tool testing platform. Built for speed, reliability, and total dominance."
    }
};
